import { render, staticRenderFns } from "./MonthSalesStatistics.vue?vue&type=template&id=5b923f88&"
import script from "./MonthSalesStatistics.vue?vue&type=script&lang=js&"
export * from "./MonthSalesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports